import { GeoPoint } from "@/types/routes";
import { useEffect, useRef } from "react";
import Map from "ol/Map";
import View from "ol/View";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { XYZ } from "ol/source";
import { Vector as VectorSource } from "ol/source";
import { Stroke, Style } from "ol/style";
import { LineString } from "ol/geom";
import Feature from "ol/Feature";

interface MapRouteProps {
    points: GeoPoint[];
    color: string;
}

export const MapRoute: React.FC<MapRouteProps> = ({ points, color }) => {
    const mapRef = useRef<HTMLDivElement>(null);
    const mapInstance = useRef<Map | null>(null);

    useEffect(() => {
        if (!mapRef.current) return;

        const coordinates = points.map(p => [p.longitude, p.latitude]);

        const vectorSource = new VectorSource({
            features: coordinates.length
                ? [
                    new Feature({
                        geometry: new LineString(coordinates).transform('EPSG:4326', 'EPSG:3857'),
                    }),
                ]
                : [],
        });

        const vectorLayer = new VectorLayer({
            source: vectorSource,
            style: new Style({
                stroke: new Stroke({
                    color: color,
                    width: 3,
                }),
            }),
        });

        // Создание карты
        const map = new Map({
            target: mapRef.current as HTMLElement,
            layers: [
                new TileLayer({
                    source: new XYZ({
                        url: "https://{a-c}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
                    }),
                }),
                vectorLayer,
            ],
            view: new View({
                center: [37.488646, 55.531162].map((coord) => coord * (Math.PI / 180)).map((rad, i) => (i === 0 ? rad * 6378137 : Math.log(Math.tan(Math.PI / 4 + rad / 2)) * 6378137)),
                zoom: 15,
                projection: 'EPSG:3857',
            }),
        });

        mapInstance.current = map;

        return () => {
            if (mapInstance.current) {
                mapInstance.current.setTarget(undefined);
            }
        };
    }, [points, color]);

    return <div ref={mapRef} className="w-full h-64 my-4 rounded-lg shadow border" />;
};
